<template>
  <nav aria-label="Primary navigation" class="navbar navbar-expand-lg navbar-dark bg-primary">
    <div class="container-fluid py-0">
      <span class="navbar-brand navbar-brand-responsive" href="#">
        <img src="../../assets/logo-reverse.png" alt="Minnesota Department of Health Logo" class="me-4 brand-logo" style="height:1.5rem;"/>
        <span class="text-white fs-4 brand-title">{{ appTitle }}</span>
      </span>

      <button  v-if="store.authenticated && !store.loadingProfile" class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-end py-2" id="navbarSupportedContent">
        <div class="d-flex flex-wrap gap-3 justify-content-start">
          <PvButton v-if="store.authenticated && !store.loadingProfile" icon="pi pi-user" arial-label="View user profile" class="nav-item" title="View your general profile details." rounded @click="toggleUserPopover" />
          <!-- <PvButton v-if="store.authenticated && !store.loadingProfile && store.user.isHceOnlyUser" title="Sign out" @click="store.logout()">Sign Out</PvButton> -->
          <AppMenu v-if="store.authenticated && !store.loadingProfile" />
        </div>
      </div>
    </div>
  </nav>
  <Popover ref="op">
    <div class="p-3 d-flex">
      <div class="me-4">
        <Avatar :label="store.user.initials" size="large" shape="circle" />
      </div>
      <div>
        {{ store.user.firstName }} {{ store.user.lastName }}
        <br />
        <small>{{ store.user.primaryOrganizationName }}</small>      
      </div>
    </div>
  </Popover>
</template>

<script setup>
// ===============================
// IMPORTS
// ===============================
// Vue Core
import { ref } from 'vue';

// Components
import Popover from 'primevue/popover';
import Avatar from 'primevue/avatar';
import AppMenu from './AppMenu.vue';

// Composables

// Stores
import { useAuthStore } from '@/stores/authStore';

// Constants and Utils

// ===============================
// PROPS & EMITS
// ===============================

// ===============================
// COMPOSABLES & STORES
// ===============================
const store = useAuthStore();

// ===============================
// REACTIVE STATE
// ===============================
const op = ref();

// ===============================
// CONSTANTS
// ===============================
const appTitle = import.meta.env.VITE_APP_TITLE;

// ===============================
// COMPUTED PROPERTIES
// ===============================

// ===============================
// METHODS
// ===============================
const toggleUserPopover = (event) => op.value.toggle(event);

// ===============================
// WATCHERS
// ===============================

// ===============================
// LIFECYCLE HOOKS
// ===============================

// ===============================
// EXPOSE
// ===============================


</script>

<style scoped>
.navbar-brand-responsive {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.25rem;
  padding: 0;
  max-width: 100%;
}

.brand-logo {
  flex-shrink: 0;
  max-width: 100%;
}

.brand-title {
  flex: 1 1 auto;
  min-width: 0; /* Allows text to shrink if needed */
}

.navbar {
  padding: .25rem 0;
}
/* Media query for high zoom levels (500% zoom roughly equals very small viewport) */
@media (max-width: 320px) {
  .navbar-brand-responsive {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
  }
  
  .brand-title {
    font-size: 1rem !important;
    line-height: 1.2;
  }
}

/* Alternative: Container query approach for more precise zoom detection */
@container (max-width: 300px) {
  .navbar-brand-responsive {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>